import { withState } from 'recompose';

export default withState('firstName', 'updateFirstName', '');
